module.exports = __webpack_public_path__ + "img/p1.3f4c9c4c.png";